export function queryResponseData<T>(result: {
  data?: T;
  error?: unknown;
  response?: Response;
}): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  if (result.response && !result.response.ok) {
    throw new Error(`Request failed: HTTP ${result.response.status}`);
  }
  if (result.data === undefined) {
    throw new Error('Request returned no query data');
  }
  return result.data;
}
